// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__3vEEr","checkbox_input":"checkbox_checkbox_input__2vF0L","checkbox_checkmark":"checkbox_checkbox_checkmark__2lZmc"};